<lib-block-title
  id="event-registry-title"
  [title]="labels.eventRegistryTitle">
</lib-block-title>
<div
  class="fx-col fx-gap-3"
  id="eventRegistry-filter">
  <form
    *ngIf="filterForm"
    class="fx-row fx-wrap fx-gap-3"
    [formGroup]="filterForm"
    (ngSubmit)="onSubmit()">
    <div class="fx-col fx-gap-1 fx-align-start p-4 border-grey-200 border-1 radius-4">
      <mat-label class="text-grey-400">{{ labels.eventFilter }}</mat-label>
      <div class="fx-row fx-gap-3 w-fit fx-wrap">
        <mat-form-field
          subscriptSizing="dynamic"
          class="custom-mat-form-field custom-border-bottom">
          <mat-select
            formControlName="azzurroEvent"
            [placeholder]="labels.eventIdPlaceholder">
            <mat-option
              *ngFor="let option of eventsOptions"
              [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          subscriptSizing="dynamic"
          class="custom-mat-form-field custom-border-bottom">
          <mat-select
            formControlName="status"
            [placeholder]="labels.statusPlaceholder">
            <mat-option
              *ngFor="let option of statusOptions"
              [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="fx-col fx-gap-1 w-fit fx-wrap p-4 border-grey-200 border-1 radius-4">
      <mat-label class="text-grey-400">{{ labels.deviceFilter }}</mat-label>
      <div class="fx-row fx-gap-3 w-fit fx-wrap">
        <mat-form-field
          subscriptSizing="dynamic"
          class="custom-mat-form-field custom-border-bottom">
          <input
            matInput
            formControlName="deviceId"
            [placeholder]="labels.deviceId">
        </mat-form-field>
        <mat-form-field
          subscriptSizing="dynamic"
          class="custom-mat-form-field custom-border-bottom">
          <mat-select
            formControlName="batteryModel"
            [placeholder]="labels.batteryModel">
            <mat-option
              *ngFor="let option of batteryModelOptions"
              [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="fx-col fx-gap-1 w-fit p-4 border-grey-200 border-1 radius-4">
      <mat-label class="text-grey-400">{{ labels.firmwareFilters }}</mat-label>
      <div class="fx-row fx-gap-3 w-fit fx-wrap">
        <mat-form-field
          subscriptSizing="dynamic"
          class="custom-mat-form-field custom-border-bottom">
          <input
            matInput
            formControlName="arm"
            [placeholder]="labels.armPlaceholder">
        </mat-form-field>
        <mat-form-field
          subscriptSizing="dynamic"
          class="custom-mat-form-field custom-border-bottom">
          <input
            matInput
            formControlName="dspm"
            [placeholder]="labels.dspmPlaceholder">
        </mat-form-field>
        <mat-form-field
          subscriptSizing="dynamic"
          class="custom-mat-form-field custom-border-bottom">
          <input
            matInput
            formControlName="dsps"
            [placeholder]="labels.dspsPlaceholder">
        </mat-form-field>
      </div>
    </div>
  </form>
  <div
    class="fx-r-row fx-gap-3">
    <customer-simple-button
      [action]="onSubmit"
      [label]="labels.applyFilters">
    </customer-simple-button>
    <customer-simple-button
      type="warning"
      [action]="resetFilter"
      [label]="labels.resetFilters">
    </customer-simple-button>
  </div>
</div>

<azzurro-table
  *ngIf="paginationConfig | async as paginationConfig"
  id="eventRegistry-table"
  [labels]="labels"
  [columns]="columns"
  [paginationConfig]="paginationConfig"
  [data$]="data$"
  [tableId]="'eventRegistry'"
  [mode]="'server'"
  [showColumnToggleButton]="true"
  [pagination]="true"
  [filterEnabled]="false"
  [noResultTemplate]="noResult"
  (pageChanged)="onPageChange($event)"
  (sortChanged)="onSortChange($event)">
</azzurro-table>


<section
  id="eventRegistry-list"
  class="fx-col radius-4 border-1 border-grey-100 radius-4 p-2">
  <div *ngIf="data$ | async as data; else skeleton">
    <div
      *ngFor="let event of data; let odd = odd"
      class="fx-col fx-gap-2 p-2 radius-4"
      [class.bg-grey-100]="odd">
      <div class="fx-row fx-justify-between">
        <div class="tw-font-medium  tw-text-grey-400">
          {{ event.azzurroEvent }}
        </div>
        <mat-chip [ngClass]="{
            'chip-level-0': event.status === 'OPEN',
            'chip-level-1': event.status === 'CLOSE'
          }">
          {{ event.status }}
        </mat-chip>
      </div>
      <div class="fx-row fx-gap-3">
        <div class="tw-text-grey-400">
          {{ event.deviceId }}
        </div>
        <div class="tw-text-grey-400">
          {{ event.batteryModel }}
        </div>
      </div>
      <div class="fx-row fx-gap-3">
        <div class="tw-text-grey-400">
          {{ event.createdAt | date: 'dd/MM/yyyy mm:ss' }}
        </div>
        <div class="tw-text-grey-400">
          {{ event.updatedAt | date: 'dd/MM/yyyy mm:ss' }}
        </div>
      </div>

    </div>
  </div>
  <mat-paginator
    *ngIf="paginationConfig | async as paginationConfig"
    class="text-grey-400"
    [pageSizeOptions]="paginationConfig.pageSizeOptions || []"
    [pageSize]="paginationConfig?.pageSize"
    [length]="paginationConfig?.length"
    (page)="onPageChange($event)">
  </mat-paginator>
</section>

<ng-template #skeleton>
  <div
    *ngFor="let _ of [].constructor(10); let first = first"
    class="tw-flex tw-flex-col tw-p-2 tw-border-grey-100"
    [class.tw-border-t]="!first">
    <div class="fx-col fx-gap-1">
      <ion-skeleton-text
        *ngFor="let _ of [].constructor(3)"
        animated
        class="w-full h-10">
      </ion-skeleton-text>
    </div>
  </div>
</ng-template>

<ng-template #noResult>
  <div class="fx-col fx-center">
    <div class="tw-font-medium tw-text-base tw-text-grey-400">
      {{ labels.noResults }}
    </div>
    <customer-simple-button
      [label]="labels.resetFilters"
      [action]="resetFilter"
      type="warning">
    </customer-simple-button>
  </div>
</ng-template>